import { Button } from '@repo/ui/button'
import { ListLayout } from '@repo/ui/components/list-layout'
import { useQuery } from '@tanstack/react-query'
import {
	createFileRoute,
	Link,
	stripSearchParams
} from '@tanstack/react-router'
import { Upload } from 'lucide-react'
import { useTranslation } from '@/lib/i18n'
import { ApplicationsPhaseNotice } from '../../-components/applications-phase'
import { WhenWritable } from '../../-components/when-writable'
import { useWorkingCall } from '../../-hooks/use-working-call'
import { managedCallQueryOptions } from '../../-query/query-options'
import { ApplicationsTable } from './-components/applications-table'
import { IntakeStatus } from './-components/intake-status'
import { applicationsSearchSchema } from './-lib/applications-search'

export const Route = createFileRoute('/(private)/bando/$residenceId/domande/')({
	component: ApplicationsPage,
	validateSearch: applicationsSearchSchema,
	search: {
		middlewares: [stripSearchParams(applicationsSearchSchema.parse({}))]
	}
})

/**
 * The applications sent to one residence: the table is the page, the figures of
 * the whole residence sit above it.
 */
function ApplicationsPage() {
	const { t } = useTranslation()
	const { residenceId } = Route.useParams()
	const { callId, readOnly } = useWorkingCall()
	const call = useQuery(managedCallQueryOptions(residenceId, callId))

	return (
		<ListLayout
			listSlot={
				<ApplicationsTable
					actions={
						!readOnly &&
						call.data?.intake.state === 'open' && (
							<Button
								nativeButton={false}
								render={
									<Link
										params={{ residenceId }}
										to='/bando/$residenceId/domande/carica'
									/>
								}
								size='sm'
							>
								<Upload />
								{t('admin-applications:intake.command')}
							</Button>
						)
					}
					residenceId={residenceId}
				>
					<WhenWritable>
						<IntakeStatus
							callId={callId}
							residenceId={residenceId}
						/>
					</WhenWritable>
					{call.data && (
						<ApplicationsPhaseNotice myCall={call.data} />
					)}
				</ApplicationsTable>
			}
			title={t('admin-applications:page_title')}
		/>
	)
}
